module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/table-component/option-view/option-view.component.css
// module id = ./src/app/components/table-component/option-view/option-view.component.css
// module chunks = main